import { useQuery } from 'hooks/useCustomQuery';
import getSRTRegionsForServiceProfile from 'API/SRT/getSRTRegionsForServiceProfile';
import { multiSelectDataMapper } from 'utils/utils';

/**
 * Regions available to an SRT service profile.
 *
 * @param {object} params
 * @param {string} params.scope `Wholesaler/{id}` or `Partner/{id}`.
 */
const useGetSRTProfileRegions = ({ scope }) => {
    return useQuery({
        queryKey: ['srtRegions', scope],
        queryFn: async () => {
            const result = await getSRTRegionsForServiceProfile(scope);
            return result.data.map(multiSelectDataMapper);
        },
    });
};

export default useGetSRTProfileRegions;
